module.exports = __webpack_public_path__ + "img/02_no.dadbe316.svg";